<ng-container *ngIf="control?.errors && control?.dirty">
  <ng-container *ngFor="let validator of validators">
    <ng-container *ngIf="control.hasError(validator.key)">
      <div class="invalid-feedback">
        {{ validator.message }}
      </div>
    </ng-container>
  </ng-container>
</ng-container>
